import React from 'react'
import { Card, CardContent, CardHeader } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'

const BillingByMonthCardSkeleton: React.FC = () => (
  <Card>
    <CardHeader className="pb-2"><Skeleton className="h-5 w-48" /></CardHeader>
    <CardContent className="space-y-2">
      {[0, 1, 2, 3, 4].map((i) => <Skeleton key={i} className="h-8 w-full" />)}
    </CardContent>
  </Card>
)
export default BillingByMonthCardSkeleton
